import React from 'react';
const SubscriptionContext = React.createContext(null);
export default SubscriptionContext;
